module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/interface/global-nav-logo-c148c618439f2a1f3f19e4eab9b3b4a9.svg";